// Copyright 2019 Sorama B.V.

export class AspectItemRatio {
    public ratio: number;
    public width: number;
    public height: number;
}

export interface IAspectItem {
    /**
     * Based on the maxWidth and maxHeight, determine the properties that this element needs to efficiently fill the available space
     * @param maxWidth
     * @param maxHeight
     */
    getArea(maxWidth: number, maxHeight: number): AspectItemRatio;
}
